export const getRandomHexColour = () => {
    // Generate a random number between 0 and 255 for each RGB component
    let red = Math.floor(Math.random() * 256);
    let green = Math.floor(Math.random() * 256);
    let blue = Math.floor(Math.random() * 256);

    // Convert the decimal values to hexadecimal and concatenate them
    return "" +
        red.toString(16).padStart(2, "0") +
        green.toString(16).padStart(2, "0") +
        blue.toString(16).padStart(2, "0");
}

export const getTextColorForHexCode = (hexCode) => {
    hexCode = '#'+hexCode;

    // Convert hex to RGB
    const r = parseInt(hexCode.slice(1, 3), 16) / 255;
    const g = parseInt(hexCode.slice(3, 5), 16) / 255;
    const b = parseInt(hexCode.slice(5, 7), 16) / 255;

    // Calculate relative luminance
    const luminance = 0.2126 * Math.pow(r, 2.2) +
        0.7152 * Math.pow(g, 2.2) +
        0.0722 * Math.pow(b, 2.2);

    // Choose text color based on luminance
    if (luminance > 0.5) {
        return '000';
    }

    return 'FFF';
}